export const CricketGenRules = [
  {
    category: 'match_odd_caps',
    rules: [
      'c_m_r_1',
      "c_m_r_2",
    ],
  },
  {
    category: 'fancy',
    rules: [
      'f_r_1',
      'f_r_2',
      'f_r_3',
      'f_r_4',
      'f_r_5',
      'f_r_6',
      'f_r_7',
      'f_r_8',
      'f_r_9',
      'f_r_10',
      'f_r_11',
      'f_r_12',
    ],
  },
  {
    category: 'player_bookmaker',
    rules: [
      'p_b_r_1',
      'p_b_r_2',
      "p_b_r_3",
      'p_b_r_4',
    ],
  },
  {
    category: 'other_fancy',
    rules: [
      'o_f_r_1',
      'o_f_r_2',
      'o_f_r_3',
      'o_f_r_4',
      'o_f_r_5',
      'o_f_r_6',
      'o_f_r_7',
    ],
  },
];

export const TestMachRules = [
  {
    category: 'session',
    rules: [
      'tm_r_1',
      'tm_r_2',
      'tm_r_3',
      'tm_r_4',
      'tm_r_5',
      'tm_r_6',
    ],
  },
  {
    category: 'test_lambi_inning_run',
    rules: [
      't_l_r_1',
      't_l_r_2',
      't_l_r_3',
    ],
  },
  {
    category: 'test_batsman',
    rules: [
      't_b_r_1',
      't_b_r_2',
      't_b_r_3',
      't_b_r_4',
      't_b_r_5',
    ],
  },
  {
    category: 'other_fancy_advance',
    rules: [
      'o_f_a_r_1',
    ],
  },
  {
    category: 'concussion_in_test',
    rules: [
      'c_t_r_1',
    ],
  },
  {
    category: 'total_match_events_test',
    rules: [
      't_m_e_r_1',
    ],
  },
];

export const T20MatchRules = [
  {
    category: 'session',
    rules: [
      's_r_1',
      's_r_2',
      's_r_3',
    ],
  },
  {
    category: 'fifty_over_runs',
    rules: [
      'f_o_r_1',
      'f_o_r_2',
    ],
  },
  {
    category: 'odi_t20_batsman_runs',
    rules: [
      'o_t_b_r_1',
      'o_t_b_r_2',
      'o_t_b_r_3',
    ],
  },
  {
    category: 't20_over_runs',
    rules: [
      't_o_r_1',
    ],
  },
  {
    category: 't20_odi_batsman_runs',
    rules: [
      't_o_b_r_1',
      't_o_b_r_2',
      't_o_b_r_3',
    ],
  },
  {
    category: 'third_umpire_decision',
      
    rules: ["t_u_d_1",],
  },
  {
    category: '1st2&3&4_wickets_runs:-T20/ODI',
      
    rules: [
      'Advance_event_is_valid_in_only_1st_Innings',
      'If_over_reduced_due_to_rain_or_weather_condition_or_match_abandoned_or_match_completed,_then_the_result_will_be_given_as_per_score',
    ],
  },
];

export const CricketCheeting = [
  {
    category: 'cheating_rules',
    rules: [
      'c_r_1',
      'c_r_2',
      'c_r_3',
      'c_r_4',
      "c_r_5",
      'c_r_8',
      "c_r_6",
      "c_r_7",
  ],
  },
];

export const RulesOfTennis = [
  {
    category: 'rules_of_tennis',
    rules: [
      't_r_1',
      't_r_2',
      't_r_3', 
      't_r_4',
      't_r_5',
      't_r_6',
    ],
  },
  {
    category: 'cheating_rules',
    rules: [
      'c_r_1',
      'c_r_2',
      'c_r_3',
      'c_r_4',
      "c_r_5",
      "c_r_6",
      'c_r_7',
    ],
  },
];

export const RulesOfSoccer = [
  {
    category: 'rules_of_football',
    rules: [
      'fb_r_1',
      'fb_r_2',
      'fb_r_3',
      'fb_r_4',
      'fb_r_5',
      'fb_r_6',
      'fb_r_7',
      'fb_r_8',
      'fb_r_9',
      'fb_r_10',
      'fb_r_11',
    ],
  },
  {
    category: 'cheating_rules',
    rules: [
      'c_r_1',
      'c_r_2',
      'c_r_3',
      'c_r_4',
      "c_r_5",
      "c_r_6",
      'c_r_7',
    ],
  },
];

export const RulesOfBinary = [
  {
    category: 'rules_of_binary',
    rules: [
      "b_r_1",
      "b_r_2",
      'b_r_3',
      'b_r_4',
      "b_r_5",
    ],
  },

   
];

export const RulesOfHorseRacing = [
  {
    category: 'rules_horse_racing',
    rules:[
      "r_h_r_1",
      "r_h_r_2",
      "r_h_r_3",
      "r_h_r_4",
      "r_h_r_5",
      "r_h_r_6",
      "r_h_r_7",
      "r_h_r_8",
      "r_h_r_9",
      "r_h_r_10",
      "r_h_r_11",
      "r_h_r_12",
      "r_h_r_13",
      "r_h_r_14",
      "r_h_r_15",
      "r_h_r_16",
      "r_h_r_17",
      "r_h_r_18",
      "r_h_r_19",
      "r_h_r_20",
      "r_h_r_21",
      "r_h_r_22",
      "r_h_r_23",
      "r_h_r_24",
      "r_h_r_25",
      "r_h_r_26",
      "r_h_r_27",
      "r_h_r_28",
      "r_h_r_29",
      "r_h_r_30",
      "r_h_r_31",
      "r_h_r_32",
      "r_h_r_33",
      "r_h_r_34",
      "r_h_r_35",
      "r_h_r_36",
      "r_h_r_37",
    ],
  },
];